export default {
  templates: [],
  loading: false,
  variablesLoading: false,
  variableList: []
}
